var r={exports:{}};export{r as g};
//# sourceMappingURL=index38.js.map
